import parse from 'html-react-parser';

// components
import { CasCRUDTable } from 'src/compass/shared/components';
import ICasRenderCellProps from 'src/compass/shared/components/CasTable/ICasRenderCellProps';
import CommissionForm from './_internal/CommissionForm';

type Props = {
  readOnly?: boolean;
};

export default function CommissionsTab({ readOnly = false }: Props) {
  return (
    <CasCRUDTable
      entityTitle="Property"
      entity="CommissionProperty"
      columns={[
        {
          field: 'property',
          sortable: false,
        },
        {
          field: 'value',
          sortable: false,
          render: ({ row }: ICasRenderCellProps) => {
            if (row.isHTML) return parse(row.value);
            return row.value;
          },
        },
      ]}
      showPagination={false}
      showAddButton={false}
      showEditSingletonButton={!readOnly}
      includeExport={false}
      editForm={CommissionForm}
      canDelete={false}
    />
  );
}
